module.exports = __webpack_public_path__ + "img/mo_super03.40d9bd9d.png";